import { useEffect, useRef } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export function PwaUpdates(): null {
  const registration = useRef<ServiceWorkerRegistration | undefined>(undefined)
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_swScriptUrl, swRegistration) {
      registration.current = swRegistration
    },
  })

  useEffect(() => {
    const onVisibilityChange = (): void => {
      if (document.visibilityState !== 'visible') return
      registration.current?.update().catch(() => {})
      if (needRefresh[0]) void updateServiceWorker(true)
    }
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => document.removeEventListener('visibilitychange', onVisibilityChange)
  }, [needRefresh, updateServiceWorker])

  return null
}
